import { Link, useNavigate } from 'react-router-dom'
import { Car, Home, ArrowLeft, Search } from 'lucide-react'

import { Button } from '@/components/ui/button'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-brand-100 opacity-40 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-indigo-100 opacity-40 blur-3xl" />
      </div>

      <div className="relative text-center max-w-lg space-y-8">
        {/* Logo */}
        <Link to="/" className="inline-flex items-center gap-2 mb-4">
          <div className="bg-brand-600 rounded-xl p-2">
            <Car className="h-5 w-5 text-white" />
          </div>
          <span className="text-lg font-bold text-gray-900">MeuDriver</span>
        </Link>

        {/* 404 illustration */}
        <div className="relative inline-block">
          <p className="text-[10rem] font-black text-gray-100 leading-none select-none">
            404
          </p>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-white rounded-full p-5 shadow-lg ring-8 ring-gray-50">
              <Car className="h-14 w-14 text-brand-600" />
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="space-y-3">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Página não encontrada
          </h1>
          <p className="text-gray-500 leading-relaxed">
            Parece que você tomou um caminho desconhecido. A página que você
            procura não existe ou foi movida para outro endereço.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            type="button"
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Button>
          <Button
            asChild
            className="gap-2 bg-brand-600 hover:bg-brand-700"
          >
            <Link to="/">
              <Home className="h-4 w-4" />
              Ir para o início
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="gap-2"
          >
            <Link to="/instrutores">
              <Search className="h-4 w-4" />
              Buscar instrutores
            </Link>
          </Button>
        </div>

        {/* Help text */}
        <p className="text-sm text-gray-400">
          Se você acredita que isso é um erro, entre em contato com nosso{' '}
          <a
            href="mailto:suporte@meudriver.com.br"
            className="text-brand-500 hover:text-brand-600 hover:underline"
          >
            suporte
          </a>
          .
        </p>
      </div>
    </div>
  )
}
